import { render, staticRenderFns } from "./chatInput.vue?vue&type=template&id=402297c2&scoped=true"
import script from "./chatInput.vue?vue&type=script&lang=js"
export * from "./chatInput.vue?vue&type=script&lang=js"
import style0 from "./chatInput.vue?vue&type=style&index=0&id=402297c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402297c2",
  null
  
)

export default component.exports